import I18n from 'I18n';
import CRMPropertyValueTypes from 'automation-ui-flow-core/fields/CRMPropertyValueTypes';
export const getOutputTypeOptions = () => [{
  text: I18n.text('automation-ui-formula-editor.action-outputs.types.string'),
  value: CRMPropertyValueTypes.STRING
}, {
  text: I18n.text('automation-ui-formula-editor.action-outputs.types.number'),
  value: CRMPropertyValueTypes.NUMBER
}, {
  text: I18n.text('automation-ui-formula-editor.action-outputs.types.bool'),
  value: CRMPropertyValueTypes.BOOL
}, {
  text: I18n.text('automation-ui-formula-editor.action-outputs.types.datetime'),
  value: CRMPropertyValueTypes.DATETIME
}, {
  text: I18n.text('automation-ui-formula-editor.action-outputs.types.enum'),
  value: CRMPropertyValueTypes.ENUM
}, {
  text: I18n.text('automation-ui-formula-editor.action-outputs.types.date'),
  value: CRMPropertyValueTypes.DATE
}, {
  text: I18n.text('automation-ui-formula-editor.action-outputs.types.phoneNumber'),
  value: CRMPropertyValueTypes.PHONE_NUMBER
}];
export const getOutputTypeString = outputType => {
  switch (outputType) {
    case CRMPropertyValueTypes.BOOL:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.bool');
    case CRMPropertyValueTypes.DATE:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.date');
    case CRMPropertyValueTypes.DATETIME:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.datetime');
    case CRMPropertyValueTypes.ENUM:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.enum');
    case CRMPropertyValueTypes.NUMBER:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.number');
    case CRMPropertyValueTypes.PHONE_NUMBER:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.phoneNumber');
    case CRMPropertyValueTypes.STRING:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.string');
    case CRMPropertyValueTypes.UNKNOWN:
      return I18n.text('automation-ui-formula-editor.action-outputs.types.unknown');
    default:
      return '';
  }
};
export const getOutputTypeList = (outputTypes = []) => {
  return I18n.formatList(outputTypes.map(output => getOutputTypeString(output)), {
    exclusive: true
  });
};